<template>
  <div>
    <div class="d-flex align-center flex-wrap" style="gap: 8px">
      <router-link target="_blank" :to="{ name: 'customer.detail', params: { id: row.customer.id } }" class="text-subtitle-1 font-weight-medium">
        {{ row.customer.name || row.customer.email || row.customer.id }}
      </router-link>
      <span class="text-caption text--secondary">{{ row.customer.email }}</span>
      <v-spacer />
      <v-chip v-if="row.withdrawal.decision" x-small :color="row.withdrawal.decision === 'accepted' ? 'green' : 'error'" outlined>
        {{ $t(`onboarding.consent-withdrawal.decision.${row.withdrawal.decision}`) }}
      </v-chip>
    </div>
    <div class="text-body-2 mt-1">
      {{ (row.organization && row.organization.name) || '—' }} · {{ $t(`onboarding.consent-withdrawal.source.${row.source}`) }} · {{ $t(`onboarding.consent-withdrawal.purpose.${row.purpose}`) }}
    </div>
    <div class="text-caption text--secondary">
      {{ $t('onboarding.consent-withdrawal.asked-on', { date: $options.filters.formatDate(row.withdrawal.requestedAt), granted: row.grantedAt ? $options.filters.formatDate(row.grantedAt) : '—' }) }}
    </div>
    <blockquote v-if="row.withdrawal.reason" class="consent-decision__reason mt-2">« {{ row.withdrawal.reason }} »</blockquote>
    <div v-if="row.withdrawal.refusal" class="text-caption mt-1">{{ $t('onboarding.consent-withdrawal.refusal', { reason: row.withdrawal.refusal }) }}</div>

    <!-- Trancher : accepter retire l'accord aujourd'hui ; refuser dit pourquoi, la personne le lit. -->
    <template v-if="!row.withdrawal.decision">
      <v-alert type="warning" dense text class="mt-3 mb-2">{{ $t('onboarding.consent-withdrawal.consequence') }}</v-alert>
      <v-textarea v-if="refusing" v-model="reason" :label="$t('onboarding.consent-withdrawal.refusal-reason')" rows="2" auto-grow outlined dense hide-details autofocus class="mb-2" />
      <div class="d-flex" style="gap: 6px">
        <v-spacer />
        <template v-if="refusing">
          <v-btn small text @click="refusing = false">{{ $t('cancel') }}</v-btn>
          <v-btn small color="error" :disabled="!reason.trim()" :loading="working" @click="decide(false)">{{ $t('onboarding.consent-withdrawal.refuse') }}</v-btn>
        </template>
        <template v-else>
          <v-btn small outlined color="error" :disabled="working" @click="refusing = true; reason = ''">{{ $t('onboarding.consent-withdrawal.refuse') }}</v-btn>
          <v-btn small color="primary" :loading="working" @click="decide(true)">{{ $t('onboarding.consent-withdrawal.accept') }}</v-btn>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import ConsentWithdrawalRepository from '@repository/ConsentWithdrawalRepository'

/**
 * Une demande de retrait de consentement, et sa décision (ZEborne seul tranche : jamais de retrait direct par la
 * personne). La même dans la file des retraits et dans le tiroir des commandes en attente. Annonce `decided`.
 */
export default {
  name: 'ConsentDecisionPanel',

  props: {
    row: { type: Object, required: true },
  },

  data() {
    return { refusing: false, reason: '', working: false }
  },

  watch: {
    'row.id'() {
      this.refusing = false
      this.reason = ''
    },
  },

  methods: {
    async decide(accept) {
      this.working = true
      try {
        await ConsentWithdrawalRepository.decide(this.row.id, accept, accept ? null : this.reason.trim())
        this.refusing = false
        this.notifySuccess(accept ? 'onboarding.consent-withdrawal.accepted-ok' : 'onboarding.consent-withdrawal.refused-ok')
        this.$emit('decided', accept)
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.working = false
      }
    },
  },
}
</script>

<style scoped>
.consent-decision__reason {
  margin: 0;
  padding: 8px 12px;
  border-left: 3px solid var(--v-primary-base);
  background: #f6f5f3;
  border-radius: 4px;
}
</style>
